/**
 * Header
 */

const header = () => {
  const headerElement = document.querySelector('.lp-header');

  if (!headerElement) return;
  const hamburger = headerElement.querySelector('.js-header-hamburger');
  const nav = headerElement.querySelector('.lp-header__nav') as HTMLInputElement;

  if (!hamburger || !nav) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      headerElement.classList.add('active');
    } else {
      headerElement.classList.remove('active');
    }
  });

  hamburger.addEventListener('click', () => {
    headerElement.classList.toggle('is-toggled');
    hamburger.classList.toggle('is-toggled');
    nav.classList.toggle('is-toggled');

    if (screen.width <= 767) document.documentElement.classList.toggle('overflow');

    if (nav.classList.contains('is-toggled')) {
      if (screen.width <= 767) {
        let offset = 90;
        let windowHeight = window.innerHeight - offset;

        nav.style.height = windowHeight + 'px';
      } else {
        nav.style.height = '0px';
      }
    }
  });
};

export default header;
